import {
  Action,
  getModule,
  Module,
  Mutation,
  VuexModule
} from "vuex-module-decorators";
import store from "@/store";
import { captureException } from "@/plugins/sentry";

@Module({
  dynamic: true,
  namespaced: true,
  store,
  name: "device"
})
class DeviceModule extends VuexModule {
  platform: string | null = null;
  versionNo: string | null = null;

  get isIos() {
    return this.platform === "iOS";
  }

  get isAndroid() {
    return this.platform === "Android";
  }

  get isBrowser() {
    return this.platform === null;
  }

  @Mutation
  private SET_DEVICE_INFO() {
    // @ts-ignore
    if (window.device !== undefined) {
      // @ts-ignore
      this.platform = window.device.platform || null;
      return;
    }
    this.platform = null;
  }

  @Mutation
  private SET_VERSION_NO(versionNo: string) {
    this.versionNo = versionNo;
  }

  @Action
  async setDeviceInfo() {
    this.SET_DEVICE_INFO();

    // @ts-ignore
    if (!window.cordova) return;
    try {
      // @ts-ignore
      const versionNo = await window.cordova.getAppVersion.getVersionNumber();
      this.SET_VERSION_NO(versionNo);
    } catch (e) {
      captureException(e as Error);
    }
  }
}

export const deviceModule = getModule(DeviceModule);
